import { signal } from "@angular/core";
export class SchemaTree {
    public children: SchemaTree[] = [];
    constructor(
        public label: string,
        public title: string | null,
        public hierarchy: string,
        public has_children: boolean,
        public elementId?: string,
        public UUID?: string,
        public level = 1,
        public expandable = false,
        public isLoading = signal<boolean>(false),
    ) { }
}